// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xq96xh0 {
  background: #f3f3f3;
  padding: 0 10px;
  font-family: Museo Sans,Arial,sans-serif;
  font-size: 36px;
  font-weight: 400;
}
.xq96xh1 {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}
@media screen and (min-width: 769px) {
  .xq96xh0 {
    font-size: 36px;
  }
}
@media screen and (max-width: 768px) {
  .xq96xh0 {
    font-size: 24px;
  }
}
@media screen and (max-width: 1024px) {
  .xq96xh1 {
    grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,2DAA2D;EAC7D;AACF","sourcesContent":[".xq96xh0 {\n  background: #f3f3f3;\n  padding: 0 10px;\n  font-family: Museo Sans,Arial,sans-serif;\n  font-size: 36px;\n  font-weight: 400;\n}\n.xq96xh1 {\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n@media screen and (min-width: 769px) {\n  .xq96xh0 {\n    font-size: 36px;\n  }\n}\n@media screen and (max-width: 768px) {\n  .xq96xh0 {\n    font-size: 24px;\n  }\n}\n@media screen and (max-width: 1024px) {\n  .xq96xh1 {\n    grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
